import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next';
import { TitleOrangeBold, Paragraph, device, FlexContainer } from 'heliocor-ui'
import 'styled-components/macro'

const TitleLine = styled.div`
    width: 100%;
    min-height: ${props => props.height};;
    display: flex;
    padding: ${props => props.padding || '1rem'};
    margin: ${props => props.margin};
    align-items: baseline;
    justify-content: space-between;
    flex-direction: column;
    @media ${device.midSize} {
        flex-direction: row;
    }
`

const ParagraphSubtitle = styled(Paragraph)`
    font-weight: 300;
    padding-top: .25rem;
    @media ${device.midSize} {
        font-weight: 300;
        margin-left: 4px;
    }
`

const ParagraphDescription = styled(Paragraph)`
    && {
        height: 1rem;
    }
`

const CommonTitle = ({translate, displayNone, description = '', descriptionExtras, padding, value, customStyle, margin = '0', subtitle, height}) => {

    const { t } = useTranslation()

    if(displayNone) return null

    return (
        <TitleLine column width='600px' padding={padding} margin={margin} height={height}>
            <div>
                <TitleOrangeBold 
                    value={value || t(translate)}
                    margin='0'
                    textTransform='none'
                    css={customStyle}
                />
                {subtitle && (subtitle.component || (
                    <ParagraphSubtitle 
                        css={subtitle.css} 
                        margin={margin} 
                        value={t(subtitle.id, subtitle?.data)}
                    />
                ))}
            </div>
            <FlexContainer column alignItems="end" justifyContent="start">
                <ParagraphDescription margin='0' value={description} />
                {descriptionExtras}
            </FlexContainer>
        </TitleLine>
    )
}

export default CommonTitle;

